import {CategoryPageQuery} from '../../graphql/CategoryPage.gql'
import {RowLinksProps} from '../GraphCMS/RowLinks/RowLinks'
import {LogoSwiper} from '../GraphCMS/RowLinks/variant'

type BrandsRowLinksProps = RowLinksProps & {
  brandsCategory: CategoryPageQuery
}
export const BrandsRowLinks = (props: BrandsRowLinksProps) => {
  const { renderer, linksVariant, brandsCategory, ...RowLinksProps } = props
  if (brandsCategory?.categories?.items) {
    const pageLinks = brandsCategory?.categories.items[0]?.children
      ?.filter((category): category is NonNullable<typeof category> => !!category && !!category.name && !!category.image)
      .map((category) => ({
        id: category.uid,
        title: category.name as string,
        url: category.url_path as string,
        asset: {
          alt: category.name as string,
          url: category.image as string,
          height: 80,
          width: 180,
          size: 2945,
          mimeType: 'image/png',
          _typename: 'Asset'
        }
      }));

    if (pageLinks && pageLinks.length > 0) {
      RowLinksProps.pageLinks = pageLinks;
    }
  }
  return <LogoSwiper {...RowLinksProps} />
}
